import apiClient from './axios';

const myAttachmentApi = {
  /**
   * GET /my-attachment/ - Fetch all attachments
   */
  getMyAttachments: async (params = {}) => {
    const response = await apiClient.get('/my-attachment/', { params });
    return response;
  },

  /**
   * GET /my-attachment/{id}/ - Fetch single attachment
   */
  getMyAttachmentById: async (id) => {
    const response = await apiClient.get(`/my-attachment/${id}/`);
    return response;
  },

  /**
   * POST /my-attachment/ - Create new attachment
   * Form data: name (string), files (file[])
   */
  createMyAttachment: async (formData) => {
    const response = await apiClient.post('/my-attachment/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  },

  /**
   * PATCH /my-attachment/{id}/ - Update attachment metadata
   * Form data: name (string), files (file[]) - optional
   */
  updateMyAttachment: async (id, formData) => {
    const response = await apiClient.patch(`/my-attachment/${id}/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  },

  /**
   * DELETE /my-attachment/{id}/ - Delete attachment
   */
  deleteMyAttachment: async (id) => {
    await apiClient.delete(`/my-attachment/${id}/`);
  },

  /**
   * PUT /my-attachment-files/{file_id}/ - Replace single file during edit
   * Form data: file (binary)
   */
  replaceAttachmentFile: async (fileId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.put(`/my-attachment-files/${fileId}/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  },

  /**
   * DELETE /my-attachment-files/{file_id}/ - Delete single file during edit
   */
  deleteAttachmentFile: async (fileId) => {
    await apiClient.delete(`/my-attachment-files/${fileId}/`);
  },

  /**
   * POST /my-attachment/export/ - Export attachments (if supported)
   */
  exportMyAttachments: async () => {
    const response = await apiClient.get('/my-attachment/export/', { 
      responseType: 'blob' 
    });
    return response;
  },

  /**
   * POST /my-attachment/import-preview/ - Preview import data
   */
  importPreview: async (formData) => {
    return apiClient.post('/my-attachment/import-preview/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  /**
   * POST /my-attachment/import-confirm/ - Confirm import
   */
  importConfirm: async (data) => {
    return apiClient.post('/my-attachment/import-confirm/', data);
  },
};

export default myAttachmentApi;